import { getProductDomain } from "./domain";

/**
 * Страницы, на которых пользователь может закрыть требования профиля
 * (имя и/или телефон). Пока пользователь на одной из них, его не нужно
 * редиректить туда же — иначе получится бесконечный цикл.
 */
export const PROFILE_COMPLETION_PATHS = ["/profile/edit", "/fsm/settings"];

/**
 * Путь, на котором закрываются требования профиля, для текущего домена:
 * в бригадном продукте это настройки FSM, в основном — редактирование профиля.
 */
export function getProfileCompletionPath(): string {
  return getProductDomain() === "brigade"
    ? "/fsm/settings"
    : "/profile/edit";
}

/** Находится ли путь на странице закрытия требований профиля. */
export function isProfileCompletionPath(pathname: string): boolean {
  return PROFILE_COMPLETION_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

/**
 * Не выполнены ли требования профиля — `GET /api/v1/users/requirements`
 * возвращает `name` и/или `phone` в `error.metadata.missing`.
 *
 * Требование телефона администраторам платформы (admin/super_admin) на сервере
 * не выставляется, поэтому отдельно проверять роль здесь не нужно.
 */
export function hasMissingProfile(missing: string[]): boolean {
  return missing.includes("name") || missing.includes("phone");
}